import { render, staticRenderFns } from "./ShinyText.vue?vue&type=template&id=591945a2&scoped=true"
import script from "./ShinyText.vue?vue&type=script&lang=js"
export * from "./ShinyText.vue?vue&type=script&lang=js"
import style0 from "./ShinyText.vue?vue&type=style&index=0&id=591945a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591945a2",
  null
  
)

export default component.exports